export const schedulingHoursBlockAriaLabel = "P4OhU";
export const startTimeAriaLabel = "_S$R2c";
export const endTimeAriaLabel = "ZykEre";
export const removeThisTimeSlotAriaLabel = "eNqjT";
export const addNewTimeSlotAriaLabel = "xVjVlc";
export default {schedulingHoursBlockAriaLabel,startTimeAriaLabel,endTimeAriaLabel,removeThisTimeSlotAriaLabel,addNewTimeSlotAriaLabel};